import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Dancing() {
  return <ImageCollectionPage title="Dancing" path="/culture/dancing" collection="culture_dancing" />;
}
